/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import News from "@/components/NewsBox";

import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import Pagination from "@mui/material/Pagination";

import Image from "next/image";
import Link from "next/link";

import langData from "@/lang.json";
import categoryData from "@/category.json";
import serviceData from "@/service.json";
import { appDispatch, appSelector } from "@/store/hooks";
import { getNews } from "@/features/admin/news";
import filter from "@/features/news";

const blog_news = () => {
  const [isActiveLang, setIsActiveLang] = useState<any>("English");
  const [isActiveCategory, setIsActiveCategory] = useState<any>("All");
  const [isActiveService, setIsActiveService] = useState<any>("All");
  const [pagination, setPagination] = useState<any>(1);
  const perPage = 9;
  const img: any = "/static/images/s-news.png";

  const imgAnimation = UseAnimation();

  const dispatch = appDispatch();
  const { data } = appSelector((state) => state.news);
  let rows: any = [];
  let maxPage = 1;
  if (data.length > 0) {
    rows = filter(data, isActiveLang, isActiveCategory, isActiveService);
    maxPage = Math.ceil(rows.length / perPage);
  }

  useEffect(() => {
    dispatch(getNews(""));
  }, [dispatch]);

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  const changeLanguage = (params: String) => {
    setIsActiveLang(params);
  };
  const changeCategory = (params: String) => {
    setIsActiveCategory(params);
    setPagination(1);
  };
  const changeService = (params: String) => {
    setIsActiveService(params);
    setPagination(1);
  };

  const handlePageChange = (page: any) => {
    setPagination(page);
  };
  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Event Activation"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content pt-0">
        <div className="container">
          <div className="row">
            <div className="col-12 heading-s"></div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-8 order-lg-1 order-last">
              <News
                rows={rows}
                page={pagination}
                perPage={perPage}
                lang={isActiveLang}
              />
              <div className="d-flex my-5 justify-content-center">
                <Stack spacing={2}>
                  {rows.length > 0 && (
                    <Pagination
                      count={maxPage}
                      page={pagination}
                      onChange={(e: any, page: any) => {
                        handlePageChange(page);
                      }}
                      sx={{ color: "#f03e58" }}
                    />
                  )}
                </Stack>
              </div>
            </div>
            <div className="col-12 col-lg-1 order-lg-2 d-sm-none"></div>
            <div className="col-12 col-lg-3 order-lg-3 order-first">
              <div className="row">
                {/* <div className="col-12 news-filter mb-4"> */}
                {/* <div className="sub-heading">
                    <h2 className="fw-bolder">View content in</h2>
                  </div> */}
                {/* <div className="category"> */}
                {/* <div className="d-flex flex-wrap gap-1">
                      {langData.map((value: any, key: any) => {
                        return (
                          <Chip
                            className={`chip ${
                              isActiveLang == value.lang ? "active" : ""
                            }`}
                            key={key}
                            label={value.lang}
                            onClick={() => changeLanguage(value.lang)}
                          />
                        );
                      })}
                    </div> */}
                {/* </div> */}
                {/* </div> */}
                <div className="col-12 mb-4 news-filter">
                  <div className="sub-heading">
                    <h2 className="fw-bolder">Category to view</h2>
                  </div>
                  <div className="category">
                    <div className="d-flex flex-wrap gap-1">
                      <Chip
                        className={`chip ${
                          isActiveCategory == "All" ? "active" : ""
                        }`}
                        label="All"
                        onClick={() => changeCategory("All")}
                      />
                      {categoryData.map((value: any, key: any) => {
                        return (
                          <Chip
                            className={`chip ${
                              isActiveCategory == value.category ? "active" : ""
                            }`}
                            key={key}
                            label={value.category}
                            onClick={() => changeCategory(value.category)}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="col-12 news-filter mb-4">
                  <div className="sub-heading">
                    <h2 className="fw-bolder">Service to view</h2>
                  </div>
                  <div className="category">
                    <div className="d-flex flex-wrap gap-1">
                      <Chip
                        className={`chip ${
                          isActiveService == "All" ? "active" : ""
                        }`}
                        label="All"
                        onClick={() => changeService("All")}
                      />
                      {serviceData.map((value: any, key: any) => {
                        return (
                          <Chip
                            className={`chip ${
                              isActiveService == value.service ? "active" : ""
                            }`}
                            key={key}
                            label={value.service}
                            onClick={() => changeService(value.service)}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default blog_news;
